<template>
<div id="secure">
    <NewTopMenu />
    <div class="container">

        <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li>
                    <a v-on:click="goAttendance()">Attendance</a>
                </li>
                <li class="is-active">
                    <a href="#">Details</a>
                </li>
            </ul>
        </nav>

        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header" style="padding: 10px;">
                        <div class="columns">
                            <div class="column">
                                <b-select id="category" name="category" v-model="category" size="is-small" style="margin-left: 10px;" @input="getAttendanceDetails(1)">
                                    <option value="school">All</option>
                                    <option v-for="kelas in kelasList" :key="kelas._id" :value="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                                </b-select>
                            </div>
                            <div class="column" style="z-index: 100 !important;">
                                <datepicker @closed="getAttendanceDetails(1)" v-model="selectedDate" wrapper-class="myDatepickerClass" placeholder="Select Date" :value="selectedDate" :class="$style.datepicker" :calendar-button="true" calendar-button-icon="fa fa-calendar" />                                
                            </div>
                            <div class="column">
                                <a class="button is-info is-small" v-on:click="downloadAsExcel()">Download As Excel</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-content" style="min-height: 300px !important;">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        
                        <div v-show="attendanceType == 1">
                            <b-button type="is-danger" rounded>Absent ({{ absentList.length }}/{{ studentCount}}) </b-button>
                            <table class="table is-fullwidth is-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th v-show="category=='school'">Class</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(absent,index) in absentList" :key="absent._id">
                                        <td>{{ (index + 1) }}</td>
                                        <td>{{ absent.firstName }} {{ absent.lastName }}</td>
                                        <td>{{ absent.kelasID.level }} {{ absent.kelasID.name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <br/>
                            
                            <b-button type="is-warning" rounded>Attend Late ({{ attendLateList.length }}/{{ studentCount}}) </b-button>
                            <table class="table is-fullwidth is-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th v-show="category=='school'">Class</th>
                                        <th>Time</th>
                                        <th>Remarks</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(attend,index) in attendLateList" :key="attend._id">
                                        <td>{{ (index + 1) }}</td>
                                        <td>{{ attend.studentID.firstName }} {{ attend.studentID.lastName }}</td>
                                        <td v-show="category=='school'">{{ attend.kelasID.level }} {{ attend.kelasID.name }}</td>
                                        <td>{{ attend.actionTime }}</td>
                                        <td>{{ displayRemarks(attend.status) }}</td>
                                        <td>{{ attend.remarks2 }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <br/>
                            
                            <b-button type="is-success" rounded>Attend On-Time ({{ attendList.length }}/{{ studentCount}}) </b-button>
                            <table class="table is-fullwidth is-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th v-show="category=='school'">Class</th>
                                        <th>Time</th>
                                        <th>Remarks</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(attend,index) in attendList" :key="attend._id">
                                        <td>{{ (index + 1) }}</td>
                                        <td>{{ attend.studentID.firstName }} {{ attend.studentID.lastName }}</td>
                                        <td v-show="category=='school'">{{ attend.kelasID.level }} {{ attend.kelasID.name }}</td>
                                        <td>{{ attend.actionTime }}</td>
                                        <td>{{ displayRemarks(attend.status) }}</td>
                                        <td>{{ attend.remarks2 }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div v-show="attendanceType != 1">                            
                            <b-button type="is-success" rounded>Attend ({{ attendList.length }}) </b-button>
                            <table class="table is-fullwidth is-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th v-show="category=='school'">Class</th>
                                        <th>Time</th>
                                        <th>Remarks</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(attend,index) in attendList" :key="attend._id">
                                        <td>{{ (index + 1) }}</td>
                                        <td>{{ attend.studentID.firstName }} {{ attend.studentID.lastName }}</td>
                                        <td v-show="category=='school'">{{ attend.kelasID.level }} {{ attend.kelasID.name }}</td>
                                        <td>{{ attend.actionTime }}</td>
                                        <td>{{ attend.remarks }}</td>
                                        <td>{{ attend.remarks2 }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import Datepicker from 'vuejs-datepicker';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")

export default {
    name: "AttendanceDetails",
    components: {
        NewTopMenu,
        Loading,
        Datepicker,
    },
    data() {
        return {
            schoolID: "",
            category: "",
            className: "school",
            isLoading: false,
            studentCount: 0,
            kelasList: [],
            attendanceList: [],
            attendList: [],
            attendLateList: [],
            absentList: [],
            selectedDate: "",
            actionDate: "",
            attendanceType: "1"
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        var currentDate = new Date();

        this.schoolID = localStorage.getItem('schoolID');
        
        this.category = this.$store.getters.getViewSubmissionsCategory;
        if (this.category.length < 1){
            this.category = localStorage.getItem('VIEW_SUBMISSIONS_CATEGORY')
        }
        console.log("163 this.category: " + this.category)
        
        this.attendanceType = this.$store.getters.getViewSubmissionsAttendanceType;
        if (this.attendanceType.length < 1){
            this.attendanceType = localStorage.getItem('VIEW_SUBMISSIONS_ATTENDANCE_TYPE')
        }
        console.log("169 this.attendanceType: " + this.attendanceType)
        
        this.actionDate = this.$store.getters.getViewSubmissionsDurationDaily;
        if (this.actionDate.length < 1){
            this.actionDate = localStorage.getItem('VIEW_SUBMISSIONS_DURATION_DAILY')
        }
        console.log("175 this.actionDate: " + this.actionDate)

        var tempGetYear = 0
        var tempStrGetMonth = ""
        var tempGetMonth = 0
        var tempGetDay = 0
        try{
            tempGetYear = this.actionDate.substring(0,4)
            tempStrGetMonth = this.actionDate.substring(4,6)
            tempGetMonth = parseInt(tempStrGetMonth)
            tempGetMonth = tempGetMonth - 1 //since in Date, month starts at 0
            tempGetDay = parseInt(this.actionDate.substring(6,8))
            this.selectedDate = new Date(tempGetYear,tempGetMonth,tempGetDay)
        }catch(err){
            console.log("183 error parsing this.actionDate, so default to today date")
            var currentDate = new Date();
            this.selectedDate = new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate())
        }
        console.log("187 this.selectedDate: " + this.selectedDate)
        
        this.getClassList()
        this.getAttendanceDetails(0)
    },
    mounted(){
    },
    methods: {
        getAttendanceDetails(caller){
            let self = this
            self.isLoading = true;
            self.attendanceList = []
            self.attendList = []
            self.attendLateList = []
            self.absentList = []

            if (caller == 1){   //called from datepicker
                var getDate = self.selectedDate.getDate();
                var getMonth = self.selectedDate.getMonth() + 1;
                if (getDate < 10){
                    getDate = "0" + getDate
                }
                if (getMonth < 10){
                    getMonth = "0" + getMonth
                }
                self.actionDate = self.selectedDate.getFullYear() + "" + getMonth + "" + getDate;
            }
            
            this.$gtag.event('attendance', {
                'event_category': 'details',
                'event_label': localStorage.getItem('schoolName'),
                'value': localStorage.getItem('schoolID')
            })

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/attendance/view/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: self.category,
                actionDate: self.actionDate,
                attendanceType: self.attendanceType
            })
            .then(response => {
                self.attendanceList = response.data.attendanceList
                console.log("237 self.attendanceList")
                console.log(self.attendanceList)
                if (self.attendanceType == "1"){
                    self.absentList = response.data.absentList
                    self.studentCount = self.attendanceList.length + self.absentList.length
                    for (var i = 0; i < self.attendanceList.length; i++){
                        if (self.attendanceList[i].status == 1){
                            self.attendList.push(self.attendanceList[i])
                        }else{
                            self.attendLateList.push(self.attendanceList[i])
                        }                    
                    }
                }else{
                    for (var i = 0; i < self.attendanceList.length; i++){
                        self.attendList.push(self.attendanceList[i])             
                    }
                }
                self.isLoading = false

            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
        downloadAsExcel(){
            let self = this;
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/exportToExcelV2/attendance/details', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                attendanceList: self.attendanceList,  //self.attendanceList would already contain the data we want to export to excel
                absentList: self.absentList,  //self.absentList would already contain the data we want to export to excel
                actionDate: self.actionDate,
                category: self.category,
                attendanceType: self.attendanceType
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "Attendance List.xlsx");
                document.body.appendChild(link);
                link.click();         
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })

        },
        sortSubmissions(arrays){
            if (this.sortBy == 1){  //points
                return _.orderBy(arrays, 'totalPoints', 'desc');  //we're using the magical lodash function here
            }else{  //dates
                return _.orderBy(arrays, 'actionDate', 'desc');  //we're using the magical lodash function here
            }            
        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        displayRemarks(status){
            console.log("entering displayRemarks with: " + status)
            if (status == 2){
                return "Late"
            }else{
                return "On-Time"
            }
        },
        getClassList(){
            let self = this

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.kelasList = response.data.kelasList                
            })
            .catch(e => {
                console.log(e)
            })
        },
        goAttendance() {
            this.$router.push({
                name: "Attendance"
            });
        },  
    },
};
</script>

<style scoped>
.myDatepickerClass{
    margin-top: 2px;
    border: 1px dotted #000;
    width: 115%;
}
.datepicker{
    margin-left: 10px;
    margin-top: 2px;
}
.bottom-border{
    border-bottom: 1px solid #CCC
}
.container{
    padding: 10px;
}
.text-center{
    text-align: center;
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/AttendanceDetails.vue